<template>
  <div class="p-3 bg-white shadow rounded-lg">
    <!--  Preview current avatar  -->
    <!--    <div v-if="modalAction !== 'create' && originImgSrc">-->
    <!--      <div class="origin-image">-->
    <!--        <img class="ml-2 w-50 bg-light" :src="originImgSrc" />-->
    <!--      </div>-->
    <!--    </div>-->

    <input
      type="file"
      name="image"
      accept="image/*"
      class="input-upload-img"
      @change="setImage"
    />

    <div
      v-if="imageSrc"
      class="my-3 d-flex align-items-center justify-content-center mx-auto"
    >
      <div class="please-crop-image-box">
        <p>{{ $t("upload_image.please_crop_image") }}</p>
      </div>
      <vue-cropper
        ref="cropper"
        :guides="guides"
        :view-mode="viewMode"
        :drag-mode="dragMode"
        :auto-crop-area="autoCropArea"
        :min-container-width="minContainerWidth"
        :min-container-height="minContainerHeight"
        :background="background"
        :rotatable="rotatable"
        :src="imageSrc"
        :img-style="imgStyle"
        :aspect-ratio="aspectRatio"
      ></vue-cropper>
      <md-button v-if="imageSrc" @click="reset">{{
        $t("upload_image.reset")
      }}</md-button>
      <md-button class="crop-btn" v-if="imageSrc" @click="cropImage">{{
        $t("upload_image.crop")
      }}</md-button>

      <div v-if="croppedImageSrc" class="cropped-image-text-box">
        <p>{{ $t("upload_image.cropped_image") }}</p>
      </div>
      <!-- Cropped image previewer -->
      <div class="cropped-image" v-if="croppedImageSrc">
        <img class="ml-2 w-50 bg-light" :src="croppedImageSrc" />
      </div>
      <md-button
        v-if="croppedImageSrc"
        @click="uploadImage"
        class="upload-image-btn"
        >{{ $t("upload_image.upload_cropped_image") }}</md-button
      >
    </div>
  </div>
</template>

<script>
import VueCropper from "vue-cropperjs";
import "cropperjs/dist/cropper.css";
import moment from "moment";

export default {
  components: {
    VueCropper
  },
  data() {
    return {
      imageSrc: "",
      croppedImageSrc: "",
      fileName: ""
    };
  },
  props: {
    originImgSrc: {
      type: String,
      default: null
    },
    modalAction: {
      type: String,
      default: "create"
    },
    viewMode: {
      type: Number,
      default: 1
    },
    dragMode: {
      type: String,
      default: "crop"
    },
    minContainerHeight: {
      type: Number
    },
    minContainerWidth: {
      type: Number
    },
    aspectRatio: {
      type: Number
    },
    responsive: {
      type: Boolean,
      default: true
    },
    restore: {
      type: Boolean,
      default: true
    },
    checkCrossOrigin: {
      type: Boolean,
      default: true
    },
    checkOrientation: {
      type: Boolean,
      default: true
    },
    crossorigin: {
      type: String
    },
    modal: {
      type: Boolean,
      default: true
    },
    guides: {
      type: Boolean,
      default: true
    },
    center: {
      type: Boolean,
      default: true
    },
    highlight: {
      type: Boolean,
      default: true
    },
    background: {
      type: Boolean,
      default: true
    },
    autoCrop: {
      type: Boolean,
      default: true
    },
    autoCropArea: Number,
    movable: {
      type: Boolean,
      default: true
    },
    rotatable: {
      type: Boolean,
      default: true
    },
    scalable: {
      type: Boolean,
      default: true
    },
    zoomable: {
      type: Boolean,
      default: true
    },
    zoomOnTouch: {
      type: Boolean,
      default: true
    },
    zoomOnWheel: {
      type: Boolean,
      default: true
    },
    wheelZoomRatio: Number,
    cropBoxMovable: {
      type: Boolean,
      default: true
    },
    cropBoxResizable: {
      type: Boolean,
      default: true
    },
    toggleDragModeOnDblclick: {
      type: Boolean,
      default: true
    },
    imgStyle: {
      type: Object
    }
  },
  methods: {
    setImage: function(e) {
      const file = e.target.files[0];
      if (file && !file.type.includes("image/")) {
        alert("Please select an image file");
        return;
      }
      if (typeof FileReader === "function") {
        const reader = new FileReader();
        reader.onload = event => {
          this.imageSrc = event.target.result;
          this.fileName = e.target.files[0].name;
          this.$emit("setImageSrc", event.target.result);

          // Rebuild cropperjs with the updated source
          if (this.$refs.cropper) {
            this.$refs.cropper.replace(event.target.result);
          }
        };
        reader.readAsDataURL(file);
      } else {
        alert("Sorry, FileReader API not supported");
      }
    },
    cropImage() {
      // Get image data for post processing, e.g. upload or setting image src
      this.croppedImageSrc = this.$refs.cropper
        .getCroppedCanvas({ imageSmoothingQuality: "low" })
        .toDataURL("image/jpeg", 0.5);
    },
    uploadImage() {
      let croppedImage = this.dataURLtoFile(
        this.croppedImageSrc,
        this.fileName
      );
      this.$emit("setCroppedImageSrc", croppedImage);
    },
    dataURLtoFile(dataurl, filename) {
      let arr = dataurl.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);

      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }

      return new File([u8arr], filename, { type: mime });
    },
    reset() {
      this.$refs.cropper.reset();
    }
  }
};
</script>

<style scoped lang="scss">
.cropped-image {
  margin: 20px 0 0;
}
.please-crop-image-box {
  text-align: left;
  font-weight: 600;
}
.cropped-image-text-box {
  margin-top: 20px;
  text-align: left;
  font-weight: 600;
}
.input-upload-img {
  margin-bottom: 10px;
}
.upload-image-btn {
  background-color: #4caf50 !important;
  margin-top: 20px;
}

.crop-btn {
  margin-left: 5px;
  background-color: #9c27b0 !important;
}

.origin-image {
  margin-bottom: 10px;
}
</style>
